var _circle, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionAwkward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 381,
    viewBox: "0 0 314 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.31,
    cy: 144.833,
    r: 144.833,
    fill: "url(#paint0_radial_1486_9804)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.2959 74.3333C55.7624 77.3333 57.3478 92.4443 66.829 74.3333C66.829 74.3333 60.8293 71.3334 58.2959 74.3333Z",
    fill: "#0E52FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2942 106.332C32.2603 110.832 34.3461 124.443 43.8274 106.332C43.8274 106.332 38.3281 101.832 35.2942 106.332Z",
    fill: "#0E52FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2956 135.333C55.7628 138.833 57.3475 153.444 66.8288 135.333C66.8288 135.333 60.8285 131.833 58.2956 135.333Z",
    fill: "#0E52FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3281 75.4219C57.4162 83.0192 57.9631 93.6555 67.4453 75.4219",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0859 105.797C34.1741 113.394 34.7209 124.031 44.2031 105.797",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3281 135.098C57.4162 142.695 57.9631 153.331 67.4453 135.098",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80.4453,
    y1: 112.531,
    x2: 129.07,
    y2: 112.531,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 185.547,
    y1: 112.531,
    x2: 234.172,
    y2: 112.531,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 164.567,
    y1: 199.653,
    x2: 212.403,
    y2: 199.35,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3643 357.859H4.65625V321.36H30.3643V357.859ZM9.60742 353.86H25.54V325.296H9.60742V353.86ZM49.1533 372.269H44.2021V315.711H49.1533V372.269ZM46.1699 340.53H29.6025V336.404H46.1699V340.53ZM74.7344 321.106C74.7344 323.307 74.2583 325.539 73.3062 327.803C72.354 330.067 70.9575 332.12 69.1167 333.96C67.2759 335.801 65.0648 337.229 62.4834 338.245L59.9443 334.563C62.1872 333.717 64.1338 332.543 65.7842 331.041C67.4346 329.538 68.6829 327.909 69.5293 326.153C70.3757 324.397 70.7988 322.715 70.7988 321.106V317.044H74.7344V321.106ZM75.75 321.106C75.75 322.672 76.1626 324.354 76.9878 326.153C77.813 327.951 79.019 329.633 80.606 331.199C82.1929 332.765 84.0654 334.013 86.2236 334.944L84.2559 338.88C81.6322 337.864 79.3893 336.362 77.5273 334.373C75.6654 332.384 74.2689 330.226 73.3379 327.898C72.4069 325.571 71.9414 323.307 71.9414 321.106V317.044H75.75V321.106ZM96.5068 321.106C96.5068 323.392 96.0519 325.708 95.1421 328.057C94.2323 330.406 92.8569 332.543 91.0161 334.468C89.1753 336.394 86.9219 337.864 84.2559 338.88L82.2246 334.944C84.4251 334.056 86.3083 332.839 87.874 331.294C89.4398 329.75 90.6353 328.089 91.4604 326.312C92.2856 324.534 92.6982 322.799 92.6982 321.106V317.044H96.5068V321.106ZM97.6494 321.106C97.6494 322.926 98.0726 324.714 98.9189 326.47C99.7653 328.226 101.003 329.813 102.632 331.231C104.262 332.649 106.198 333.759 108.44 334.563L106.028 338.245C103.405 337.272 101.172 335.907 99.3315 334.151C97.4907 332.395 96.1048 330.385 95.1738 328.121C94.2428 325.857 93.7773 323.519 93.7773 321.106V317.044H97.6494V321.106ZM110.154 347.132H58.5479V343.006H110.154V347.132ZM103.489 372.142H98.4746V357.352H64.1338V353.289H103.489V372.142ZM119.041 380.013H114.344L117.835 362.747H123.992L119.041 380.013ZM192.801 371.38H156.238V351.258H192.801V371.38ZM161.126 367.317H187.913V355.193H161.126V367.317ZM192.801 348.274H187.786V315.774H192.801V348.274ZM200.291 333.865H190.389V329.676H200.291V333.865ZM152.303 340.467C154.969 340.424 157.201 340.329 159 340.181C160.798 340.033 162.776 339.726 164.935 339.261L165.442 343.45C163.073 343.958 160.872 344.297 158.841 344.466C156.81 344.635 154.63 344.72 152.303 344.72H149.827V340.467H152.303ZM163.919 324.026H154.588V342.815H149.827V319.837H163.919V324.026ZM170.14 340.467C173.694 340.424 176.413 340.34 178.296 340.213C180.18 340.086 182.179 339.769 184.295 339.261L184.866 343.45C182.496 343.958 180.232 344.297 178.074 344.466C175.916 344.635 173.271 344.72 170.14 344.72H167.347V340.467H170.14ZM182.327 324.026H172.107V342.688H167.347V319.837H182.327V324.026ZM209.939 335.643H216.795V321.106H221.048V358.431H205.687V321.106H209.939V335.643ZM216.795 354.305V339.578H209.939V354.305H216.795ZM229.808 335.643H236.536V321.106H240.662V358.431H225.555V321.106H229.808V335.643ZM236.536 354.305V339.578H229.808V354.305H236.536ZM251.644 372.142H246.883V315.711H251.644V372.142ZM306.551 345.037H301.663V315.711H306.551V345.037ZM306.614 361.224H274.939V369.349H270.052V357.479H301.663V351.702H269.925V347.767H306.614V361.224ZM308.646 371.507H270.052V367.508H308.646V371.507ZM279.383 323.709C279.383 326.967 278.706 330.025 277.352 332.881C275.997 335.738 274.093 338.224 271.639 340.34C269.184 342.456 266.37 344.043 263.196 345.101L260.848 341.165C263.683 340.234 266.19 338.88 268.37 337.103C270.549 335.325 272.252 333.283 273.479 330.977C274.707 328.671 275.32 326.248 275.32 323.709V320.662H279.383V323.709ZM280.335 323.709C280.335 326.121 280.949 328.417 282.176 330.596C283.403 332.776 285.117 334.68 287.317 336.309C289.518 337.938 292.036 339.176 294.871 340.022L292.396 343.895C289.264 342.879 286.482 341.387 284.048 339.419C281.615 337.452 279.721 335.114 278.367 332.405C277.013 329.697 276.336 326.798 276.336 323.709V320.662H280.335V323.709ZM293.348 323.074H262.117V318.948H293.348V323.074Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1486_9804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.31 144.833) rotate(90) scale(144.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92ECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1EFF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionAwkward);
export default __webpack_public_path__ + "static/media/IconEmotionAwkward.b09b40b5c9f1729d84825fc729b1e425.svg";
export { ForwardRef as ReactComponent };